<template>
    <!-- 组合管理 -->
    <el-tabs v-model="activeColumn" type="border-card" class="tabs-card-one">
        <el-tab-pane name="one" label="FOF">
            <combinationDetails></combinationDetails>
        </el-tab-pane>
        <el-tab-pane name="two" label="MOM">
            <mom></mom>
        </el-tab-pane>
        <el-tab-pane name="three" label="报告观点">
            <macroAnalysis></macroAnalysis>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import combinationDetails from "./combinationDetails.vue"
import mom from "./mom.vue"
import macroAnalysis from "./macroAnalysis.vue"
export default {
    name: "marketOverview",
    components: {
        combinationDetails,
        mom,
        macroAnalysis,
    },
    data() {
        return {
            activeColumn: 'one',
        }
    },
}
</script>

<style lang="less" scoped>
</style>